import React from 'react';
import css from './StudentIntakeStatusBar.scss';
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';
import PropTypes from 'prop-types';
import { getPrintIntakeURL } from "utils/intake";
import { getDateFormat } from "utils/time";
import moment from 'moment';

function StudentIntakeStatusBar({authorName, lastUpdatedDate, abbreviatedTZ, studentId, isEditable, onEditClick,
                                  canEditIntakeForm, multipleStudentSurveysEnabled}) {

  const getLastUpdatedDate = () => {
    // If survey has never been saved before, do not display anything
    if (!lastUpdatedDate) return;

    return (
      <span className={css['last-updated']}>
        {multipleStudentSurveysEnabled
          ? `Submitted by ${authorName} on ${moment(lastUpdatedDate).format(getDateFormat('dateTimeDisplayFormat'))} ${abbreviatedTZ}`
          : `Last updated ${moment(lastUpdatedDate).format("MMMM D, YYYY hh:mm A")}`
        }
      </span>
    )
  };

  const getEditButton = () =>
    (!isEditable && canEditIntakeForm &&
      <StyledButton 
        data-testid="edit-button" 
        asLink 
        aria-disabled={false} 
        onClick={onEditClick}
        arial-label="Edit"
        title="Edit"
      >
        <Icon icon='edit' aria-hidden='true' />
      </StyledButton>
    );

  const getPrintButton = () => (
    <StyledButton
      className={css['print-button']}
      asLink
      aria-disabled={false}
      onClick={() => window.open(getPrintIntakeURL(studentId))}
      arial-label="Print"
      title="Print"
    >
      <Icon icon='local_printshop' aria-hidden='true' />
    </StyledButton>
  );

  return (
    <>
      <div className={css['status-block']}>
        {getLastUpdatedDate()}
        <div className={css['action-buttons']}>
          {getEditButton()}
          {getPrintButton()}
        </div>
      </div>
    </>
  );
}

StudentIntakeStatusBar.propTypes = {
  authorName: PropTypes.string,
  lastUpdatedDate: PropTypes.string,
  abbreviatedTZ: PropTypes.string,
  studentId: PropTypes.number.isRequired,
  isEditable: PropTypes.bool.isRequired,
  onEditClick: PropTypes.func.isRequired,
  canEditIntakeForm: PropTypes.bool.isRequired,
  multipleStudentSurveysEnabled: PropTypes.bool
};

export default StudentIntakeStatusBar;
